import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[msd-patient-diary-row]',
  templateUrl: './patient-diary-row.component.html',
  styleUrls: ['./patient-diary-row.component.scss'],
})
export class PatientDiaryRowComponent {
  @Input() name: string;
  @Input() initials: string;
  @Input() pictureUrl?: string;
  @Input() diaryCount = 0;
  @Input() lastDiaryDate?: Date;
  @Output() onNameClick = new EventEmitter();

  DocumentType = DocumentType;

  get formattedLastDiary(): string {
    if (!this.lastDiaryDate) return '--';

    const date = moment(this.lastDiaryDate).local();
    return date.isSame(moment(), 'day')
      ? date.format('HH:mm')
      : date.format('DD.MM.yyyy');
  }
}
